import React from 'react';
import {
  Alert,
  Box,
  Button,
  Link,
  TextField,
  Typography,
} from '@mui/material';
import { useLocation, useNavigate, Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const LoginPage = () => {
  const { login, error, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/images';

  const [form, setForm] = React.useState({ username: '', password: '', scope: '' });
  const [submitting, setSubmitting] = React.useState(false);
  const [localError, setLocalError] = React.useState(null);

  const handleChange = (field) => (event) => {
    setLocalError(null);
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setLocalError(null);
    try {
      await login(form);
      navigate(from, { replace: true });
    } catch (err) {
      setLocalError(err.message || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          width: '100%',
          maxWidth: 420,
          padding: 4,
          boxShadow: 3,
          borderRadius: 2,
          backgroundColor: 'background.paper',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Sign in
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Enter your credentials to access the gallery.
        </Typography>

        {localError || error ? (
          <Alert severity="error">{localError || error}</Alert>
        ) : null}

        <TextField
          label="Username"
          value={form.username}
          onChange={handleChange('username')}
          autoComplete="username"
          required
          fullWidth
        />
        <TextField
          label="Password"
          type="password"
          value={form.password}
          onChange={handleChange('password')}
          autoComplete="current-password"
          required
          fullWidth
        />
        {false && <TextField
          label="Scope (optional)"
          value={form.scope}
          onChange={handleChange('scope')}
          fullWidth
        />}

        <Button type="submit" variant="contained" disabled={submitting} fullWidth>
          {submitting ? 'Signing in…' : 'Sign in'}
        </Button>

        <Typography variant="body2" color="text.secondary">
          Need help? Contact the administrator to request access.
        </Typography>

        <Link component={RouterLink} to="/" variant="body2" underline="hover">
          Back to gallery
        </Link>
      </Box>
    </Box>
  );
};

export default LoginPage;
